import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  thumbnailContainer: {
    marginBottom: 16,
    position: "relative",
  },
  thumbnailImageContainer: {
    [theme.breakpoints.up("md")]: {
      width: 291,
      height: 164,
    },
    [theme.breakpoints.down("sm")]: {
      width: 175,
      height: 100,
    },
  },
  thumbnailImage: {
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "cover",
  },
  thumbnailTitle: {
    fontSize: 14,
    maxWidth: "100%",
    whiteSpace: "normal",
    overflow: "hidden",
  },
  thumbnailPlayIcon: {
    position: "absolute",
    cursor: "pointer",
    [theme.breakpoints.up("md")]: {
      transform: "translate(250%, 125%)",
    },
    [theme.breakpoints.down("sm")]: {
      transform: "translate(125%, 50%)",
    },
  },
}));
